'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherSearch, FeatherX } from '@subframe/core';
import { Button, Select, TextField } from '@/shared/components/ui';
import { DEFAULT_TRIAL_FILTERS, type TrialListFilters as TrialListFiltersType, type TrialStatus } from '../types';
interface TrialListFiltersProps {
  filters: TrialListFiltersType;
  onChange: (patch: Partial<TrialListFiltersType>) => void;
  onClear: () => void;
}
const STATUS_OPTIONS: {
  value: TrialStatus | 'TODOS';
  label: string;
}[] = [{
  value: 'TODOS',
  label: 'Todos os status'
}, {
  value: 'ATIVO',
  label: 'Ativos'
}, {
  value: 'EXPIRADO',
  label: 'Expirados'
}, {
  value: 'ENCERRADO',
  label: 'Encerrados'
}, {
  value: 'CONVERTIDO',
  label: 'Convertidos'
}];
const isFiltering = (filters: TrialListFiltersType): boolean => filters.status.length > 0 || filters.busca.trim().length > 0 || filters.dataExpiracaoInicio !== null || filters.dataExpiracaoFim !== null;
export function TrialListFilters(t0) {
  const $ = _c(36);
  const {
    filters,
    onChange,
    onClear
  } = t0;
  const activeStatus = filters.status[0] ?? "TODOS";
  let t1;
  if ($[0] !== filters) {
    t1 = isFiltering(filters);
    $[0] = filters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showClear = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = value => {
      if (value === "TODOS") {
        onChange({
          status: []
        });
      } else {
        onChange({
          status: [value as TrialStatus]
        });
      }
    };
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleStatusChange = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherSearch />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onChange) {
    t4 = event => onChange({
      busca: event.target.value
    });
    $[5] = onChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== filters.busca || $[8] !== t4) {
    t5 = <div className="flex-1"><TextField label="Buscar por cliente" icon={t3}><TextField.Input placeholder="Nome do tenant" value={filters.busca} onChange={t4} /></TextField></div>;
    $[7] = filters.busca;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Select.Content>{STATUS_OPTIONS.map(_temp)}</Select.Content>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== activeStatus || $[12] !== handleStatusChange) {
    t7 = <div className="w-full md:w-56"><Select label="Status" value={activeStatus} onValueChange={handleStatusChange} placeholder="Selecione">{t6}</Select></div>;
    $[11] = activeStatus;
    $[12] = handleStatusChange;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = filters.dataExpiracaoInicio ?? "";
  let t9;
  if ($[14] !== onChange) {
    t9 = event_0 => onChange({
      dataExpiracaoInicio: event_0.target.value || null
    });
    $[14] = onChange;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <div className="w-full md:w-44"><TextField label="Expira a partir de"><TextField.Input type="date" value={t8} onChange={t9} /></TextField></div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = filters.dataExpiracaoFim ?? "";
  let t12;
  if ($[19] !== onChange) {
    t12 = event_1 => onChange({
      dataExpiracaoFim: event_1.target.value || null
    });
    $[19] = onChange;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <div className="w-full md:w-44"><TextField label={"Expira at\xE9"}><TextField.Input type="date" value={t11} onChange={t12} /></TextField></div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== onClear || $[25] !== showClear) {
    t14 = showClear && <Button variant="neutral-tertiary" size="medium" icon={<FeatherX />} onClick={() => onClear()} className="self-end">Limpar filtros</Button>;
    $[24] = onClear;
    $[25] = showClear;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== showClear) {
    t15 = !showClear && <div className="hidden md:block md:w-0"><span className="sr-only">{DEFAULT_TRIAL_FILTERS.busca}</span></div>;
    $[27] = showClear;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t10 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t5 || $[34] !== t7) {
    t16 = <div className="bg-default-background flex w-full flex-col gap-3 rounded-[16px] border border-solid border-neutral-200 p-4 md:flex-row md:items-end">{t5}{t7}{t10}{t13}{t14}{t15}</div>;
    $[29] = t10;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t5;
    $[34] = t7;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}
function _temp(option) {
  return <Select.Item key={option.value} value={option.value}>{option.label}</Select.Item>;
}